<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Job Information</h3>
       </template>
       <div class="row">
          <nav>
             <ol class="breadcrumb arr-right bg-breadcrum">
                <li class="breadcrumb-item">
                   <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active">Active Employees</li>
                <li class="breadcrumb-item">
                   <router-link to="/hr/inactive">&nbsp;Inactive Employees</router-link>
                </li>
             </ol>
          </nav>
       </div>
       <hr style="margin-top:-10px"/>
       <div class="row">
          <div class="col-md-5">
             <p><i class="fa fa-search"></i> Search Employee</p>
             <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
          </div>
          <div class="col-md-3">
             <div class="form-group">
                <p><i class="fa fa-filter"></i>&nbsp;Filter by Position:</p>
                <select v-model="filter_by_position" class="form-control" required>
                   <option value="">Default</option>
                   <option v-for="pos in positions"  v-text="pos.pos_name"></option>
                </select>
             </div>
          </div>
          <div class="col-md-1">
             <div class="form-group">
                <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                <select v-model="order_by" class="form-control" required>
                   <option value="">Default</option>
                   <option value="-1">ASC</option>
                   <option value="1">DESC</option>
                </select>
             </div>
          </div>
          <div class="col-md-1">
             <div class="form-group">
                <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                <select v-model="page_limit" class="form-control" required>
                   <option value="">Default</option>
                   <option value="5">5</option>
                   <option value="10">10</option>
                   <option value="25">25</option>
                   <option value="50">50</option>
                   <option value="100">100</option>
                   <option value="500">500</option>
                </select>
             </div>
          </div>
          <div class="col-md-2">
             <div class="form-group">
                <p><i class="fa fa-filter"></i>&nbsp;Filter by Status:</p>
                <select v-model="filter_by_status" class="form-control" required>
                   <option value="">Default</option>
                   <option value="regular">regular</option>
                   <option value="probationary">probationary</option>
                   <!-- <option value="promoted">promoted</option> -->
                   <option value="trainee">trainee</option>
                   <option value="terminated">terminated</option>
                   <option value="resigned">resigned</option>
                   <option value="awol">AWOL</option>
                </select>
             </div>
          </div>
       </div>
       <hr>
       <!-- PAGINATION -->
       <b-pagination
       v-model="curentPage"
       :total-rows="items.length"
       :per-page="perPage"
        aria-controls="my-table"
        align="right"
        first-text="First"
        prev-text="Prev"
        next-text="Next"
        last-text="Last"
       ></b-pagination>
       <!-- END PAGINATION -->
       <hr>
       <div class="table-responsive ">
          <table class="table table-striped table-hover "  v-loading="loading">
             <thead>
                <tr>
                   <th>Id</th>
                   <th>Employee</th>
                   <th>Basic Salary</th>
                   <th>Allowance</th>
                   <th><i class="fa fa-calendar"></i>Joined Date</th>
                   <th><i class="fa fa-calendar"></i>Date Signed</th>
                   <th><i class="fa fa-calendar"></i>Regularization Date</th>
                   <th>Status</th>
                   <th>Action</th>
                </tr>
             </thead>
             <tbody>
                <tr v-for="item , i in computedJobInformation" >
                   <template v-if="item === 'no data found'">
                      <td colspan="100%">
                         <h4>  <i class="fa fa-database"></i> Empty Records ...</h4>
                      </td>
                   </template>
                   <template v-else>
                      <td>{{i+1}}</td>
                      <td> <b>{{item.full_name | capitalize}}</b> <br/> <i>{{item.position_name}}</i></td>
                      <td><span>&#8369;</span>{{formatMoney(item.basic_salary)}}</td>
                      <td><span>&#8369;</span>{{formatMoney(item.monthly_allowance)}}</td>
                      <td>
                         <span v-if="item.employment_date !== null"> {{ getDate(item.employment_date)}}</span>
                         <span v-else>-------------------</span>    
                      </td>
                      <td>
                         <span v-if="item.date_signed !== null"> {{ getDate(item.date_signed)}}</span>
                         <span v-else>-------------------</span>      
                      </td>
                      <td>
                         <span v-if="item.regularization_date !== null"> {{ getDate(item.regularization_date)}}</span>
                         <span v-else>-------------------</span>    
                      </td>
                      <td>
                         <span v-if="item.status == 'probationary'">
                         <i class="fa fa-flag text-info"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'trainee'">
                         <i class="fa fa-flag text-warning"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'regular'">
                         <i class="fa fa-flag text-success"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'promoted'">
                         <i class="fa fa-flag text-secondary"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'resigned'">
                         <i class="fa fa-flag text-danger"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'terminated'">
                         <i class="fa fa-flag text-danger"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'awol'">
                         <i class="fa fa-flag text-danger"></i>&nbsp;{{item.status}}
                         </span>
                      </td>
                      <td>
                         <router-link :to="{name: 'view-job-information', params: { id: item.id }}" class="btn btn-xs btn-default" v-b-tooltip.hover title="click to view full details of job information"><i class="fa fa-eye"></i>View</router-link>
                         <a href="#"  class="btn btn-xs btn-default" @click="get_selected_id(item)" v-b-modal.update-job-information v-b-tooltip.hover title="click to update employee job information"><i class="fa fa-pencil"></i>Update</a>
                      </td>
                   </template>
                </tr>
             </tbody>
          </table>
            <!-- PAGINATION NATIVE WAY -->
            <div class="row">
                <div class="col-md-6">
                    <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
                </div>
                <div class="col-md-6">
                    <b-pagination
                        v-model="curentPage"
                        :total-rows="items.length"
                        :per-page="perPage"
                        aria-controls="my-table"
                        align="right"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                    ></b-pagination>
                 </div>
             </div>
          <!-- END PAGINATION -->
          <!-- MODAL FOR UPDATE RECORD  -->
          <b-modal id="update-job-information" ref="hide-modal-job-information"  size="xl"   title="Update Item"  hide-footer>
             <h3>{{selected_user.full_name | capitalize}}</h3>
             <div class="row">
                <div class="col-md-4">
                   <div class="form-group">
                      <label><i class="fa fa-calendar"></i>&nbsp;Employment Date:</label>
                      <input type="date" class="form-control" v-model="selected_user.employment_date">
                   </div>
                   <div class="form-group">
                      <label><i class="fa fa-calendar"></i>&nbsp;Date Signed:</label>
                      <input type="date" class="form-control"  v-model="selected_user.date_signed">
                   </div>
                </div>
                <div class="col-md-4">
                   <div class="form-group">
                      <label><i class="fa fa-calendar"></i>&nbsp;Resignation Date:</label>
                      <input type="date" class="form-control" v-model="selected_user.resignation_date">
                   </div>
                   <div class="form-group">
                      <label><i class="fa fa-calendar"></i>&nbsp;Promoted Date:</label>
                      <input type="date" class="form-control" v-model="selected_user.promoted_date">
                   </div>
                </div>
                <div class="col-md-4">
                   <div class="row">
                      <div class="col-md-6">
                         <div class="form-group">
                            <label><i class="fa fa-calendar"></i>&nbsp;Training Start:</label>
                            <input type="date" class="form-control" v-model="selected_user.training_start">
                         </div>
                      </div>
                      <div class="col-md-6">
                         <div class="form-group">
                            <label><i class="fa fa-calendar"></i>&nbsp;Training End:</label>
                            <input type="date" class="form-control" v-model="selected_user.training_end">
                         </div>
                      </div>
                   </div>
                   <div class="form-group">
                      <label><i class="fa fa-calendar"></i>&nbsp;Regularization Date:</label>
                      <input type="date" class="form-control" v-model="selected_user.regularization_date">
                   </div>
                </div>
             </div>
             <hr/>
             <div class="row">
                <div class="col-md-4">
                   <div class="form-group">
                      <label>Basic Salary:</label>
                      <input type="number" v-model="selected_user.basic_salary" v-mask="['#########']"  class="form-control" placeholder="0.00">
                   </div>
                </div>
                <div class="col-md-4">
                   <div class="form-group">
                      <label>Monthly Allowance:</label>
                       <input type="number" v-model="selected_user.monthly_allowance" v-mask="['#########']" class="form-control" placeholder="0.00">
                   </div>
                </div>
                <div class="col-md-4">
                   <div class="form-group">
                      <label>Employment Status:</label>
                      <select  class="form-control" v-model="selected_user.status" @change="supervisor_subtitute">
                         <option value="trainee">Trainee</option>
                         <option value="probationary">Probationary</option>
                         <option value="regular">Regular</option>
                         <option value="terminated">Terminated</option>
                         <option value="resigned">Resigned</option>
                         <option value="awol">AWOL</option>
                      </select>
                   </div>
                </div>
             </div>
             <div class="row">
                <div class="col-md-12">
                   <div class="form-group">
                      <label>Note:</label>
                      <textarea rows="3" class="form-control" v-model="selected_user.note"></textarea>
                   </div>
                </div>
             </div>
             <div class="form-group">
                <button class="btn btn-info float-right" @click="update_job_information"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
             </div>
          </b-modal>
       </div>
       <!-- MODAL FOR UPDATE CHANGE TEAM -->
       <b-modal id="select_supervisor" ref="get_supervisor"  size="l" hide-footer>
          <h3 class="c-padding">Supervisor Subtitute</h3>
          <div class="form-group">
             <label>Select Supervisor:</label>
             <select class="form-control" v-model="subtitute_id" @change="get_superiorname">
                <option value="">--Select One--</option>
                <option v-for="sup in supervisor" v-bind:value="sup.id">{{sup.full_name | capitalize}} - {{sup.position_name}}</option>
             </select>
          </div>
          <div class="form-group">
           <b-alert show variant="danger">    
                <i class="fa fa-warning"></i> <i>Please select a subtitute for <b>{{selected_user.full_name}}</b> to his/her job position.</i>
           </b-alert> 
          </div>
          <div class="form-group">
             <button class="btn btn-info float-right" @click="update_supervisor"><i class="fa fa-save"></i> Update Changes</button>
          </div>
          <br/><br/><br/>
       </b-modal>
          <!-- If Lost Connection on Server    -->
             <!-- <template v-if="display_indicator === 1">
                 <center>
                     <br/><br/>
                     <img  src="/static/img/warning.png"  width="225" height="190">
                 <h1>You've lost your network connection</h1>
                 <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
                 <br/><br/>
             </center>
          </template> -->
    </card>
 </template>
 <script>  
 /* eslint-disable */ 
 import Card from 'src/components/UIComponents/Cards/Card.vue' 
  export default {
    components: {
      Card
   },
   data() {
      return {
         items: [],
         positions: [],
         selected_user: '',
         search: '',
         supervisor:[],
         filter_by_position: '',
         filter_by_status: '',
         order_by: '',
         subtitute_id:'',
         page_limit: '',
         start_page: 1,
         display_indicator: '',
         loading: true,
         superior_name:{},
         member_item:[],
         //PAGINATION
         perPage: 200,
         curentPage:1,
         others_salary: "",
         others_allowance: "",
      }
   },
   mounted: function() {
        this.get_jobinformation()
        this.get_positions()
   },
   methods: {
    /**
     * GET SUPERIOR NAME BASED ON DROWPDOWN SELECTION ON MODAL
     */      
    get_superiorname(){
                   axios 
                       .get('api/superiorname/get/' + this.subtitute_id)
                       .then(resp=>{this.superior_name = resp.data})
                       .catch(error=>{console.log(error)})
                },
    /**
     * UPDATE SUPERIOR ROLES AND JOBINFORMATION 
     */ 
     update_supervisor(){
       if(this.subtitute_id != ''){
          axios
            .post('api/superiorroles/update/' + this.selected_user.emp_id, {
               'subtitute_id': this.subtitute_id,
               'superior_name':this.superior_name.full_name,
               'status':this.selected_user.status 
            })
            .then(resp=>{
                if(resp.data.response == 'success'){
                    this.$swal({'title':'Save', text:resp.data.message, type:'success', timer: 2000,showConfirmButton: true});
                    this.$refs['hide-modal-job-information'].hide()
                    this.$refs['get_supervisor'].hide()
                    this.get_jobinformation()   
                 }else if(resp.data.response == 'error'){
                    this.$swal({'title':'Oops', text:resp.data.message, type:'error',showConfirmButton: true});
                 }
            })
            .catch(error=>{
                console.log(error)
            })
        }else{
             this.$swal({'title':'Oops', text:'Please select supervisor to subtitute.', type:'error',showConfirmButton: true});
        }  
        
     },
    
       
    /**
     * IF RESIGNED AND ROLE IS 2 THE MODAL WILL POP UP 
     */     
     supervisor_subtitute(){
          if(((this.selected_user.status == 'resigned') || (this.selected_user.status == 'awol') || (this.selected_user.status == 'terminated')) &&  this.member_item.length != 0){
              if(this.selected_user.resignation_date != null){
                     this.$refs['get_supervisor'].show()
                     axios.get('api/supervisor/get/' + this.selected_user.emp_id)
                    .then(resp => { this.supervisor = resp.data; })
                    .catch(error => { console.log(error.response) });
                    this.$refs['get_supervisor'].show()
               }else{
                     this.$swal({'title':'Opps', text:'Please input or select Resignation date to proceed.', type:'error', timer: 3000,showConfirmButton: true});
                     this.selected_user.status = 'regular'
               }  
          } 
     },

     /**
     * GET JOBINFORMATION
     */
      get_jobinformation() {
         axios.get('api/jobinformation')
            .then(response => {
               this.items = response.data;
               this.display_indicator = 2;
               this.loading = false;
            })
            .catch(e => {
               console.log(e.response)
               this.display_indicator = 1;
            })
      },
      /**
       * GET POSITIONS
       */
      get_positions() {
         axios.get('api/positions')
            .then(response => {
               this.positions = response.data;
            })
            .catch(e => {
               console.log(e.response)
            })
      },
  
      get_selected_id(item) {
         this.selected_user = item;
         axios.get('api/checkmember/'+ this.selected_user.emp_id)
            .then(resp => { this.member_item = resp.data })
            .catch(error => { console.log(error.response) });
      },
    /**
     * UPDATE JOB INFORMATION RECORD
     */
      update_job_information(e) {
         e.preventDefault();
         this.$swal({
               title: 'Are you sure?',
               text: 'Do you want to  update this record.',
               type: 'warning',
               showCancelButton: true,
               showCloseButton: false,
            })
            .then((isConfirm) => {
               if (isConfirm === true) {
                  //--> HTTP POST REQUEST 
                    axios.post('api/jobinformation/update/' + this.selected_user.id, {
                        'employee_id': this.selected_user.emp_id,
                        'employment_date': this.selected_user.employment_date,
                        'date_signed': this.selected_user.date_signed,
                        'regularization_date': this.selected_user.regularization_date,
                        'training_start': this.selected_user.training_start,
                        'training_end': this.selected_user.training_end,
                        'resignation_date': this.selected_user.resignation_date,
                        'promoted_date': this.selected_user.promoted_date,
                        'basic_salary':this.selected_user.basic_salary,
                        'status': this.selected_user.status,
                        'monthly_allowance': this.selected_user.monthly_allowance,
                        'note': this.selected_user.note
                        })
                        .then(resp => {
                        if(resp.data.response == 'success'){
                                    this.$swal({'title':'Updated', text:resp.data.message, type:'success', timer: 2000,showConfirmButton: true});
                                    this.$refs['hide-modal-job-information'].hide()
                                    this.get_jobinformation()
                        }else if(resp.data.response == 'error'){
                                this.$swal({'title':'Opps', text:resp.data.message, type:'error', timer: 3000,showConfirmButton: true});
                        }   
                        })
                        .catch(error => {
                        console.log(error);
                        })
                 //--> END HTTP POST REQUEST   
              }
        })
      }
   },

   computed: {

      offset() {  return (this.start_page - 1) * this.page_limit; },
      limit() { return this.offset + this.page_limit; },   
      total_item(){ return this.items.length }, 

      computedJobInformation() {
        let filtered = this.items
         // USE IN PAGINATION 
          let start = (this.curentPage-1) * this.perPage
          let end = this.curentPage * this.perPage
          filtered = filtered.slice(start, end)

          if(filtered.length > 0){
            // SEARCH BY EMPLOYEE FULLNAME
            if (this.search) {
            filtered = filtered.filter(
                item => item.full_name.toLowerCase().indexOf(this.search) > -1
            );
            return filtered
            }
            // FILTER BY POSITION
            if (this.filter_by_position) {
            filtered = filtered.filter(
                item => item.position_name.toLowerCase() === this.filter_by_position.toLowerCase()
            );
            return filtered
            }
            // ORDER BY ASC AND DESC COMBOBOX
            if (this.order_by) {
            filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
            return filtered
            }
            // SORTING NUMBER OF DISPLAY
            if (this.page_limit) {
            filtered = filtered.slice(this.offset, this.limit);
            return filtered
            }
            // FILTER BY STATUS
            if (this.filter_by_status) {
            filtered = filtered.filter(
                item => item.status.toLowerCase() === this.filter_by_status.toLowerCase()
            );
            return filtered
            }
          }
         return filtered
      }
   },

  
   watch:{
         subtitute_id: function (val) {
               console.log(val)
        },    
   }
}
</script>
<style>
    .position{
        color :#ebebeb;
    }
    .bg-breadcrum{
         background:#fff;
     }      
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-job-information/todo-job-information.vue